type IProps = {
	pathClassName?: string;
	svgClassName?: string;
};

const CloseSvg = (props: IProps) => {
	return (
		<svg
			className={props?.svgClassName ?? ''}
			width="8"
			height="8"
			viewBox="0 0 8 8"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				className={props?.pathClassName ?? ''}
				d="M3.99987 4.88621L1.29466 7.59121C1.17397 7.71204 1.02765 7.77107 0.855705 7.76829C0.683622 7.76565 0.537234 7.70399 0.416539 7.58329C0.295845 7.4626 0.235497 7.31489 0.235497 7.14017C0.235497 6.96544 0.295845 6.81774 0.416539 6.69704L3.11362 3.99996L0.408622 1.31558C0.287789 1.19489 0.228761 1.04718 0.231539 0.872458C0.234178 0.697875 0.295845 0.550236 0.416539 0.429541C0.537234 0.308708 0.684942 0.248291 0.859664 0.248291C1.03439 0.248291 1.18209 0.308708 1.30279 0.429541L3.99987 3.13454L6.68425 0.429541C6.80494 0.308708 6.95126 0.248291 7.12321 0.248291C7.29529 0.248291 7.44168 0.308708 7.56237 0.429541C7.69168 0.558708 7.75633 0.7085 7.75633 0.878917C7.75633 1.04933 7.69168 1.19489 7.56237 1.31558L4.86529 3.99996L7.57029 6.70517C7.69112 6.82586 7.75154 6.97218 7.75154 7.14413C7.75154 7.31621 7.69112 7.4626 7.57029 7.58329C7.44112 7.7126 7.29133 7.77725 7.12091 7.77725C6.9505 7.77725 6.80494 7.7126 6.68425 7.58329L3.99987 4.88621Z"
				fill={'#C64040'}
			/>
		</svg>
	);
};
export default CloseSvg;
